export default __webpack_public_path__ + "static/media/noimage1.26123e52.jpg";